<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
      <div class="row" v-if="userData.permissions['insurance_patients']==1">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-insurance-company size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Insurance Company</b-button>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
               
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button @click="edit(data.item.id,data.item.name,data.item.contact,data.item.email,data.item.address)" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row justify-content-center">
          <div class="col-md-8 col-xl-6">
            <div>
              <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
              <center><span class="text-primary h6">You have no permission to View Refered Patients</span></center>
            </div>
          </div>
        </div>
      </div>
  
      <b-modal id="new-insurance-company" centered title="New Insurance Company" title-class="font-18" hide-footer>
          <form @submit.prevent="addInsuranceCompany">
            
              <div class="form-group mb-2">
              <label> Name</label>
                <input v-model="name" type="text" class="form-control"/>
              </div>
              <div class="form-group mb-2">
              <label>Contact</label>
                <input v-model="contact" type="text" v-mask="'##########'" class="form-control"/>
              </div>
              <div class="form-group mb-2">
              <label>Email</label>
              <input v-model="email" type="email" required class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Address</label>
              <input v-model="address" type="text" required class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-insurance-company')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
              <br><br><center><span class="text-danger">{{ error }}</span></center>

          </form>
      </b-modal>
  
      <b-modal id="edit-insurance-company" centered title="Edit Insurance Company" title-class="font-14" hide-footer>
          <form @submit.prevent="editInsuranceCompany">
              
            <div class="form-group mb-2">
              <label> Name</label>
                <input v-model="name" type="text" class="form-control"/>
              </div>
              <div class="form-group mb-2">
              <label>Contact</label>
                <input v-model="contact" type="text" class="form-control"/>
              </div>
              <div class="form-group mb-2">
              <label>Email</label>
              <input v-model="email" type="email" required class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Address</label>
              <input v-model="address" type="text" required class="form-control" />
              </div>
              <!-- <div class="form-group mb-2">
                      <b-form-group label="Insurance Logo" description="insurancelogo">
                        <input type="file" class="form-control" v-on:change="onLogoChange">
                      </b-form-group>
                    </div>
                   
                     <span v-if="item.insurancelogo!=0">
                      <img :src="getFiles(item.insurancelogo)"  height="70px"/>
                    </span>
                    <span v-else>
                        <img src="@/assets/images/insurancelogo.png" height="70px"/>
                    </span> -->
                   
                    <!-- <div class="form-group"><br> -->
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-insurance-company')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="delete-insurance-company" centered title="Delete Insurance Company " title-class="font-18" hide-footer>
          <form @submit.prevent="removeInsuranceCompany">
              <input v-model="id" type="hidden">
                Are you sure you want to delete <b>{{ name }}</b> Insurance Comapny ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-insurance-company')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
              </div>
          </form>
      </b-modal>
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { insurancesMethods, insurancesComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Insurance Companies",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader,
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Insurance Companies",
        items: [ {text: "Dashboard",to: "/",}, {text: "Insurance Companies",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'name', label: 'Name', visible: true },
            { key: 'contact', label: 'Contact', visible: true },
            { key: 'email', label: 'Email', visible: true },
            { key: 'address', label: 'Address', visible: true },
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'',
        name:'',
        email:'',
        contact:'',
        address:'',
        error:'',
        // insurancelogo: "",
      };
    },
    computed: {
      ...insurancesComputed,
      List() { return this.insurancecompanies.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.insurancecompanies.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.insurancecompanies.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchInsurances();
      this.TotalRows = this.insurancecompanies.length;
      this.isBusy=false;
    },
    methods: {
      ...insurancesMethods,
    //   onLogoChange(e){ this.insurancelogo = e.target.files[0]; },
    // getFiles(name){
    //  let url = axios.defaults.baseURL;
    //  let imagelink = (url).slice(0,-3)+"logos/"+name;
    //  return imagelink;
    // },
      customLabel ({ patient_id, name, telephone }) {
        return `${patient_id} – ${name} – ${telephone}`
      },
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      edit(id,name,contact,email,address){
        this.id=id;
        this.name=name;
        this.contact=contact;
        this.email=email;
        this.address=address;
        this.$bvModal.show('edit-insurance-company')
      },
      
     
      remove(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('delete-insurance-company')
      },
      async addInsuranceCompany() { 
        this.error = "Saving Company";
        let formData = new FormData();
        formData.append("name", this.name);
        formData.append("contact", this.contact);
        formData.append("email", this.email);
        formData.append("address", this.address);
        // formData.append("insurancelogo", this.insurancelogo);
        let url = "/addinsurance";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchInsurances();
            this.$bvModal.hide('new-insurance-company');
            this.name="";
            this.contact="";
            this.email="";
            this.address="";
            // this.insurancelogo="";
            this.$toast.success("New Insurance Company Added");
            this.error="";
        }
        });
      },
      async editInsuranceCompany(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("contact", this.contact);
      formData.append("email", this.email);
      formData.append("address", this.address);
      let url = "/updateinsurance";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchInsurances();
          this.$bvModal.hide('edit-insurance-company');
            this.name="";
            this.contact="";
            this.email="";
            this.address="";
            this.$toast.success("Insurance Company Updated");
        }
      });
      },
      async removeInsuranceCompany() { 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      let url = "/removeinsurance";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchInsurances();
          this.$bvModal.hide('delete-insurance-company');
          this.$toast.error("Insurance Company Deleted");
        }
      });
      },
    },
  };
  </script>